import './App.scss';
import Navbar from './component/Navbar/Navbar';
import Header from './pages/Header/Header';
import About from './pages/About/About';
import Work from './pages/work/Work'
import Skills from './pages/Skills/Skills';
import Footer from './pages/footer/Footer';

function App() {
  return (
    <div className='app'>
      <Navbar/>
      <Header/>
      <About/> 
      <Work/> 
      <Skills/>
      <Footer/> 
    </div>
  );
}

export default App;
